import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  addMovingAverage as addMA,
  chartActive as chartactive,
  chartSize as _chartSize,
  removeMovingAverage as removeMA,
  toLiquidity as _toLiquidity,
  updateChart as updatechart,
  updateTimeFrame,
} from './actions'
import { movingAverage, WithChartState } from './reducer'

type UseChartReturn = [
  boolean,
  number,
  Record<number, movingAverage>,
  {
    updateTimeframe(payload: number): void
    updateChart(payload: boolean): void
    addMovingAverage(payload: movingAverage): void
    removeMovingAverage(payload: { type: string; number: number }): void
  }
]

type UseChart = () => UseChartReturn

export const useChart: UseChart = () => {
  const timeFrame = useSelector((state: WithChartState) => state.chart.timeFrame)
  const isLine = useSelector((state: WithChartState) => state.chart.line)
  const movingAverages = useSelector((state: WithChartState) => state.chart?.movingAverage)
  const dispatch = useDispatch()

  const updateTimeframe = useCallback(
    (timeframe: number) => {
      dispatch(updateTimeFrame({ timeframe }))
    },
    [dispatch]
  )
  const updateChart = useCallback(
    (line: boolean) => {
      dispatch(updatechart({ line }))
    },
    [dispatch]
  )
  const addMovingAverage = useCallback(
    ({ color, number, type }: movingAverage) => {
      dispatch(addMA({ color, number, type }))
    },
    [dispatch]
  )
  const removeMovingAverage = useCallback(
    ({ type, number }: { type: string; number: number }) => {
      dispatch(removeMA({ type, number }))
    },
    [dispatch]
  )

  return [
    isLine,
    timeFrame,
    movingAverages,
    { updateTimeframe, updateChart, addMovingAverage, removeMovingAverage },
  ]
}

type UseActivateReturn = [
   boolean,
  {
    width: number
    height: number
  },
  boolean,
  {
    chartActive(payload: boolean): void
    updateChartSize(payload: { height: number; width: number }): void
    toLiquidity(payload :boolean): void
  }
]
type UseActivateChart = () => UseActivateReturn

export const useActivateChart: UseActivateChart = () => {
    const dispatch = useDispatch()
    const chartSize = useSelector((state: WithChartState) => state.chart.chartSize)
    const isActive = useSelector((state: WithChartState) => state.chart.active)
    const toLP = useSelector((state: WithChartState) => state.chart.LPLink)
    const chartActive = useCallback(
    (active: boolean) => {
      dispatch(chartactive({ active }))
    },
    [dispatch]
  )  
  const toLiquidity = useCallback(
    (active: boolean) => {
      dispatch(_toLiquidity(active))
    },
    [dispatch]
  ) 
  const updateChartSize = useCallback(
    ({ height, width }: { height: number; width: number }) => {
      dispatch(_chartSize({ height, width }))
    },
    [dispatch]
  )
  return [isActive, chartSize, toLP, { chartActive, updateChartSize, toLiquidity }]
}